import { LinkInterface } from 'atomic/utilization/link/link.interface';
import classNames from 'classnames';

import './link.scss';

export default function getLinkClasses(props: Pick<LinkInterface, 'block' | 'uppercase' | 'size'| 'weight'>): string {
    const LinkClass = classNames({
        [`link--${props.size}`]: true,
        [`link--fw-${props.weight}`]: true,
        'link--block': props.block,
        'link--uppercase': props.uppercase
    });

    return LinkClass;
}
